
















import { Component, Vue, Watch } from "vue-property-decorator";
import FinancesTable from "@/components/finances/PagedFinancesTable.vue";
import GlobalFilterSensitiveMixin from "@/mixins/GlobalFilterSensitiveMixin";
import ReservationModal from "@/components/reservation-form/ReservationModal.vue";
import { Action } from "vuex-class";

@Component({
  components: {
    FinancesTable,
    ReservationModal,
  },
  mixins: [GlobalFilterSensitiveMixin],
})
export default class Finances extends Vue {
  @Action("globalFilters/refreshFilter") refreshFilter?: ( replace?: boolean ) => void;

  reservationModalOpen = false;
  reservationId = 0;
  loaded = false;
  
  async openModal(reservationId: number) {
    this.reservationId = reservationId;
    let reservationExists = false;
    
    await Vue.axios
      .get<boolean>(`Reservations/ReservationExists/${this.reservationId}`)
      .then((res) => {
        reservationExists = res.data;

        if(reservationExists){
          this.reservationModalOpen = true;
        }
        else{        
          this.$store.dispatch("showNotification", {
            color: "error",
            message: this.$t("Reservation.Deleted"),
            timeout: 5000,
          });
        }
      });      
  }

  async created() {
    if(this.refreshFilter){
      this.refreshFilter();
    }
  }

  @Watch("sensitiveKey", {immediate: false})
  watchSensitiveKeyChange()
  {
    this.loaded = true;
  }
}
